import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Login from './Login';
import { login } from '../actions';
import * as selectors from '../selectors';

export class LoginContainer extends Component {
  handleSubmit = values =>
    this.props.login(
      values.get('email'),
      values.get('password'),
      this.props.history
    );

  render() {
    const { ui } = this.props;
    return (
      <Login
        onSubmit={this.handleSubmit}
        location={this.props.location}
        isLoading={ui.get('isLoading')}
        isError={ui.get('isError')}
        errorMessage={ui.get('errorMessage')}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  ui: selectors.getUI
});

export default connect(mapStateToProps, { login })(LoginContainer);



// WEBPACK FOOTER //
// ./src/modules/auth/components/LoginContainer.js